import { render, staticRenderFns } from "./FormListEntry.vue?vue&type=template&id=515a3385&"
import script from "./FormListEntry.vue?vue&type=script&lang=ts&"
export * from "./FormListEntry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports